import React from "react";
import { StyledQuotaDisplayBar, StyledQuotaBar, StyledUnderBar, StyledQuotaBarSpan } from "./styles";
import { useHistory } from "react-router-dom";
import Utils from "../../../Utils";
import { PRICING_PLANS } from "../../../../../src/shared/constants";

const QuotaBar = ({ subscription, zeroPercentLeft }) => {
  let history = useHistory();

  if (!subscription || !subscription.usesQuota) return null;

  const userPlan = subscription.currentPlan;
  let wordsLeft = subscription.totalQuota; // note: this also calculates credits left for v4 plans
  if (wordsLeft < 0) wordsLeft = 0;

  let allotment = subscription.activeTrial ? PRICING_PLANS[subscription.data.version].trialQuota : userPlan.allotment;
  if (subscription.totalQuota > allotment) {
    allotment = subscription.totalQuota;
  }
  const fillBarAmount = wordsLeft >= allotment ? 100 : (wordsLeft / allotment) * 100;

  const overage = (userPlan && userPlan.allowOverage) || false;
  const canPurchasePacks = (userPlan && userPlan.allowPurchaseQuota) || false;
  const inOverage = (userPlan && userPlan.allowOverage && subscription.overageCost > 0) || false;
  const price = (userPlan && userPlan.price) || 0;

  const displayOverage = subscription.overageCost;

  let fallbackMessage = canPurchasePacks ? "." : ", upgrade your plan to keep using Sudowrite AI functions.";

  if (subscription.overageWords > 0 && overage) {
    fallbackMessage = `, and you've used ${Utils.numberWithCommas(subscription.overageWords)} additional words ($${displayOverage}) this billing cycle.`;
  }

  const billingPeriodFallback = price === 0 ? ` in your limited free plan.` : ` this billing period.`;

  if (subscription.lapsed) {
    return (
      <StyledQuotaBar>
        <StyledUnderBar>
          <StyledQuotaBarSpan>Sudowrite's AI features are only available with active plans.</StyledQuotaBarSpan>
        </StyledUnderBar>
      </StyledQuotaBar>
    );
  }

  const content = (
    <>
      <StyledQuotaBarSpan>
        {`${Utils.numberWithCommas(wordsLeft)} ${subscription.usesLedgers ? "credits" : "AI words"} left`}
        {wordsLeft === 0 ? (
          <>{subscription.activeTrial || price === 0 ? `, sign up for a plan to keep using Sudowrite.` : fallbackMessage} </>
        ) : (
          <>{subscription.activeTrial ? ` in free trial.` : billingPeriodFallback}</>
        )}
      </StyledQuotaBarSpan>
    </>
  );

  return (
    <StyledQuotaBar>
      {!inOverage && (
        <StyledQuotaDisplayBar filledAmount={fillBarAmount}>
          <div />
        </StyledQuotaDisplayBar>
      )}
      <StyledUnderBar>{content}</StyledUnderBar>
    </StyledQuotaBar>
  );
};

export default QuotaBar;
